import React from "react";
import { cn } from "./utils";

const variants = {
  primary:   "bg-blue-600 text-white hover:bg-blue-700 disabled:bg-gray-300",
  indigo:    "bg-indigo-600 text-white hover:bg-indigo-500 shadow-sm",
  dark:      "bg-gray-900 text-white hover:bg-gray-800",
  secondary: "text-gray-600 hover:bg-gray-100",
  ghost:     "text-gray-400 hover:text-gray-700 hover:bg-gray-100",
  outline:   "border border-gray-200 text-gray-700 hover:bg-gray-50",
  danger:    "bg-red-600 text-white hover:bg-red-700",
};

const sizes = {
  sm: "h-8 px-3 text-[12px]",
  md: "h-9 px-4 text-[13px]",
  lg: "h-10 px-5 text-[14px]",
  icon: "h-9 w-9 p-0",
};

export function RaboButton({
  children,
  className,
  variant = "primary",
  size = "md",
  disabled,
  style,
  ...props
}) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-1.5 rounded-lg font-medium transition-colors disabled:cursor-not-allowed shrink-0",
        variants[variant],
        sizes[size],
        className
      )}
      style={style}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
